var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"providerSection"},[_c('NavBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }